import CustomerFollowManagement from './CustomerFollowManagement.vue'

export default CustomerFollowManagement


// WEBPACK FOOTER //
// ./src/pages/CustomerFollowManagement/index.js